import { render, staticRenderFns } from "./social-media-icon.vue?vue&type=template&id=34bf86be&scoped=true&"
import script from "./social-media-icon.vue?vue&type=script&lang=js&"
export * from "./social-media-icon.vue?vue&type=script&lang=js&"
import style0 from "./social-media-icon.vue?vue&type=style&index=0&id=34bf86be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bf86be",
  null
  
)

export default component.exports